import {
  Component,
  EventEmitter,
  Input,
  inject,
  OnInit,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { PostTradeService } from '../../post-trade.service';
import { SessionStorageService } from '../../../services/session-storage.service';
import isEmpty from 'lodash-es/isEmpty';
import { RbGridComponent } from '../../../shared-components/rb-grid/rb-grid.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-search-account-grid',
  templateUrl: './search-account-grid.component.html',
  styleUrls: ['./search-account-grid.component.scss'],
  imports: [MatIconModule, RbGridComponent, MatButtonModule],
})
export class SearchAccountGridComponent implements OnInit, OnDestroy {
  @ViewChild(RbGridComponent) rbGrid: RbGridComponent;
  @Input() defaultSearchIds: Array<string> = [];
  @Output() setShellAccount = new EventEmitter();

  fb = inject(FormBuilder);
  ptSvc = inject(PostTradeService);
  ss = inject(SessionStorageService);
  private location = inject(Location);
  private route = inject(Router);

  rights = [];
  unsubscribe: Subject<any> = new Subject();
  gridConfig = {
    gridName: 'SearchAccount',
    showGridFilters: false,
    showFilterManager: false,
    manualSearch: true,
    searchButtonText: 'Search Results',
    showBulkActions: false,
    downloadGridButton: false,
    gridActionColumn: true,
    rowSelector: 'DirectAccountID',
    gridType: 'search-account',
    detailViewRoute: '/account-linking/',
    showGridColumnFilters: false,
    resetBtnText: 'See Default Accounts',
    additionalResetFunc: this.toggleFilters.bind(this),
    gridActions: [
      {
        icon: 'contact_emergency',
        color: 'primary',
        text: 'Select for Compare',
        action: this.selectShellAccount.bind(this),
      },
    ],
  };

  ngOnInit(): void {
    this.rights = this.ss.get('rights');
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  toggleFilters() {
    this.gridConfig.showGridFilters = !this.gridConfig.showGridFilters;
  }

  getGridSetup() {
    return this.ptSvc.getSearchAccountSetup();
  }

  selectShellAccount(ev, dataItem) {
    this.setShellAccount.emit(dataItem);
  }

  getGridData = queryData => {
    let reqData = queryData;

    if (typeof reqData === 'string') {
      reqData = JSON.parse(reqData);
    }

    if (isEmpty(reqData['search'])) {
      reqData['search']['AccountID'] = { selected: this.defaultSearchIds };
    }

    return this.ptSvc.getSearchAccountGridData(JSON.stringify(reqData));
  };
}
